import React from 'react';
import Skeleton from '@mui/material/Skeleton';

import styles from './styles.module.scss';

interface Props {
  /** Mimics a TerritoryCard row instead of an ActionCard one. */
  territory?: boolean;
}

/** Grey stand-in for a map panel row while its data loads. */
const CardSkeleton = ({ territory }: Props) => (
  territory ? (
    <div className={`${styles.card} ${styles.territory}`} aria-hidden>
      <Skeleton variant="text" width="60%" height={32} />
      <Skeleton variant="text" width="30%" height={26} />
    </div>
  ) : (
    <div className={`${styles.card} ${styles.action}`} aria-hidden>
      <Skeleton variant="text" width="40%" height={16} />
      <span className={styles.name}>
        <Skeleton variant="text" width="90%" height={22} />
        <Skeleton variant="text" width="55%" height={22} />
      </span>
      <Skeleton variant="rounded" width={96} height={25} />
      <Skeleton variant="rounded" width="60%" height={10} />
    </div>
  )
);

export default CardSkeleton;
